import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Quality_Control_Plan_Table = ({ setEdit }) => {
  const data = [
    {
      date: "12 Jan 2025",
      type: "Use Of CRM/Srms",
      frequency: "Quarterly",
      parameter: "ASH%",
      criteria: 26.5,
    },
    {
      date: "",
      type: "",
      frequency: "",
      parameter: "VM%",
      criteria: 26.5,
    },
    {
      date: "",
      type: "",
      frequency: "",
      parameter: "GCV(K.Cal/Kg)",
      criteria: 26.5,
    },
    {
      date: "10 Jan 2025",
      type: "Use Of CRM/Srms",
      frequency: "Quarterly",
      parameter: "ASH%",
      criteria: 26.5,
    },
    {
      date: "",
      type: "",
      frequency: "",
      parameter: "VM%",
      criteria: 26.5,
    },
    {
      date: "",
      type: "",
      frequency: "",
      parameter: "GCV(K.Cal/Kg)",
      criteria: 26.5,
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              {" "}
              <tr>
                {" "}
                <th>
                  {" "}
                  <input type="checkbox" />{" "}
                </th>{" "}
                <th>Date</th> <th>Type Of Verification</th> <th>Frequency</th>{" "}
                <th>Parameter</th> <th>Acceptance Parameter Criteria</th>{" "}
              </tr>{" "}
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date || "-"}</td>
                  <td>{row.type || "-"}</td>
                  <td>{row.frequency || "-"}</td>
                  <td>{row.parameter}</td>
                  <td>{row.criteria}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Quality_Control_Plan_Table;
